//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import translations from '~/i18n/services';

export default {
    props: {
        related: {
            type: Array,
            required: true,
        },
    },
    computed: {
        items() {
            const items = [];

            this.related.forEach((relatedService) => {
                const service = translations[relatedService][this.$i18n.locale];

                if (service) {
                    items.push({
                        title: service.type,
                        description: service.description,
                        slug: relatedService,
                    });
                }
            });

            return items;
        },
    },
};
